import _xor from 'lodash/xor';
import _keys from 'lodash/keys';
import _isEmpty from 'lodash/isEmpty';

/**
 * Checks if two objects have the same keys
 * @param {Object} obj1 - obj 1
 * @param {Object} obj2 - obj 2
 *
 * @returns {Boolean} - true if objects have the same keys
 */
export default function(obj1, obj2) {
  let keys1 = _keys(obj1);
  let keys2 = _keys(obj2);

  let difference = _xor(keys1, keys2);

  return _isEmpty(difference);
}
